@if (hasEligibility) {
  <ki-dropdown
    [selectedOption]="selectedOption"
    [options]="eligibilityStatuses"
    [config]="config"
    semanticLabel="Eligibility Status"
    (optionChanged)="optionsChanged($event)"></ki-dropdown>
}
